"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccordion = void 0;
const react_1 = require("react");
function useAccordion(defaultActiveKey) {
    const [state, setState] = (0, react_1.useState)({
        activeKey: defaultActiveKey
    });
    const onToggle = (0, react_1.useCallback)((key) => {
        setState(state => {
            if (state.activeKey === key) {
                return Object.assign(Object.assign({}, state), { activeKey: undefined });
            }
            return Object.assign(Object.assign({}, state), { activeKey: key });
        });
    }, [setState]);
    const handleToggle = (0, react_1.useCallback)((key) => () => onToggle(key), [
        onToggle
    ]);
    return { onToggle, handleToggle, state };
}
exports.useAccordion = useAccordion;
//# sourceMappingURL=useAccordion.js.map